class NetworkScanApiService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://compliance-backend.cloudsanalytics.ai';
  }

  async scanPorts(agentId) {
    try {
      const accessToken = localStorage.getItem('cognito_token');
      const headers = {
        'Content-Type': 'application/json',
      };
      
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      const response = await fetch(`${this.baseUrl}nmap/scan`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          agent_id: agentId,
          scan_type: "summary"
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error scanning ports:', error);
      throw error;
    }
  }

  // Helper method to categorize ports by risk level
  categorizePorts(ports) {
    const categories = {
      critical: [],
      high: [],
      medium: [],
      low: []
    };

    const riskMapping = {
      // Critical risk ports
      21: 'critical',    // FTP
      23: 'critical',    // Telnet
      135: 'critical',   // RPC
      139: 'critical',   // NetBIOS
      445: 'critical',   // SMB
      1433: 'critical',  // SQL Server
      3389: 'critical',  // RDP
      
      // High risk ports
      25: 'high',        // SMTP
      53: 'high',        // DNS
      110: 'high',       // POP3
      143: 'high',       // IMAP
      993: 'high',       // IMAPS
      995: 'high',       // POP3S
      5432: 'high',      // PostgreSQL
      3306: 'high',      // MySQL
      
      // Medium risk ports
      80: 'medium',      // HTTP
      443: 'medium',     // HTTPS
      8080: 'medium',    // HTTP Alt
      8000: 'medium',    // HTTP Alt
      3000: 'medium',    // Development
      4000: 'medium',    // Development
      
      // Low risk ports
      22: 'low',         // SSH
      587: 'low',        // SMTP Submission
      465: 'low',        // SMTPS
    };

    ports.forEach(port => {
      const risk = riskMapping[port.port] || 'medium';
      categories[risk].push(port);
    });

    return categories;
  }

  // Get port risk level
  getPortRisk(portNumber) {
    const riskMapping = {
      21: 'critical', 23: 'critical', 135: 'critical', 139: 'critical', 
      445: 'critical', 1433: 'critical', 3389: 'critical',
      25: 'high', 53: 'high', 110: 'high', 143: 'high', 
      993: 'high', 995: 'high', 5432: 'high', 3306: 'high',
      80: 'medium', 443: 'medium', 8080: 'medium', 8000: 'medium', 
      3000: 'medium', 4000: 'medium',
      22: 'low', 587: 'low', 465: 'low'
    };
    
    return riskMapping[portNumber] || 'medium';
  }

  // Get port description
  getPortDescription(portNumber, serviceName) {
    const descriptions = {
      21: 'File Transfer Protocol - Unencrypted file transfer',
      22: 'Secure Shell - Encrypted remote access',
      23: 'Telnet - Unencrypted remote access (HIGH RISK)',
      25: 'Simple Mail Transfer Protocol',
      53: 'Domain Name System',
      80: 'Hypertext Transfer Protocol',
      110: 'Post Office Protocol v3',
      135: 'Microsoft RPC Endpoint Mapper',
      139: 'NetBIOS Session Service',
      143: 'Internet Message Access Protocol',
      443: 'HTTPS - Encrypted web traffic',
      445: 'Server Message Block - File sharing',
      465: 'SMTP over SSL/TLS',
      587: 'SMTP Submission',
      993: 'IMAP over SSL/TLS',
      995: 'POP3 over SSL/TLS',
      1433: 'Microsoft SQL Server',
      3000: 'Development server (common)',
      3306: 'MySQL Database',
      3389: 'Remote Desktop Protocol',
      4000: 'Development server (common)',
      5432: 'PostgreSQL Database',
      8000: 'HTTP Alternative',
      8080: 'HTTP Alternative'
    };

    return descriptions[portNumber] || `${serviceName} service on port ${portNumber}`;
  }
}

const networkScanApiService = new NetworkScanApiService();

export default networkScanApiService;
